module.exports = __webpack_public_path__ + "static/media/BreadBoard.1b99079e.glb";